import React from "react";
import { useField } from "formik";

import SelectTemperatura from "./SelectTemperatura";

function FormikSelectTemperatura(props) {
  const [field, meta] = useField({ name: "etapaId", ...props });

  return <SelectTemperatura {...field} {...meta} {...props} />;
}

export default FormikSelectTemperatura;
